import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../pages/AreaPage.css";

const AREAS = [
 
  { label: "Koramangala", href: "/mobile-repair-service-in-koramangala" },
  { label: "HSR Layout", href: "/mobile-repair-service-in-hsr-layout" },
  { label: "Electronic City", href: "/mobile-repair-service-in-electronic-city" },
  { label: "Whitefield", href: "/mobile-repair-service-in-whitefield" },
  { label: "Mahadevapura", href: "/mobile-repair-service-in-mahadevapura" },
  { label: "Jayanagar", href: "/mobile-repair-service-in-jayanagar" },
  { label: "Rajajinagar", href: "/mobile-repair-service-in-rajajinagar" },
  { label: "Malleswaram", href: "/mobile-repair-service-in-malleswaram" },
  { label: "Marathahalli", href: "/mobile-repair-service-in-marathahalli" },
  { label: "JP Nagar", href: "/mobile-repair-service-in-jp-nagar" },
  { label: "Banashankari", href: "/mobile-repair-service-in-banashankari" },
  { label: "KR Puram", href: "/mobile-repair-service-in-kr-puram" },
  { label: "Vijayanagar", href: "/mobile-repair-service-in-vijayanagar" },
  { label: "Rajarajeshwari Nagar", href: "/mobile-repair-service-in-rajarajeshwari-nagar" },
  { label: "BTM Layout", href: "/mobile-repair-service-in-btm-layout" },
  { label: "Bommanahalli", href: "/mobile-repair-service-in-bommanahalli" },
  { label: "Domlur", href: "/mobile-repair-service-in-domlur" },
  { label: "Kundalahalli", href: "/mobile-repair-service-in-kundalahalli" },
  { label: "RT Nagar", href: "/mobile-repair-service-in-rt-nagar" },
  { label: "Ulsoor", href: "/mobile-repair-service-in-ulsoor" },
  { label: "Seshadripuram", href: "/mobile-repair-service-in-seshadripuram" },
  { label: "Kalyan Nagar", href: "/mobile-repair-service-in-kalyan-nagar" },
  { label: "Hebbal", href: "/mobile-repair-service-in-hebbal" },
  { label: "Nagarbhavi", href: "/mobile-repair-service-in-nagarbhavi" },
  { label: "Sarjapur Road", href: "/mobile-repair-service-in-sarjapur-road" },
  { label: "Richmond Town", href: "/mobile-repair-service-in-richmond-town" },
  { label: "Peenya", href: "/mobile-repair-service-in-peenya" },
  { label: "Yeshwanthpur", href: "/mobile-repair-service-in-yeshwanthpur" },
  { label: "Nagawara", href: "/mobile-repair-service-in-nagawara" },
  { label: "Bagalur", href: "/mobile-repair-service-in-bagalur" },
  { label: "Indiranagar", href: "/mobile-repair-service-in-indiranagar" },
  { label: "Bellandur", href: "/mobile-repair-service-in-bellandur" },
  { label: "Hebbagodi", href: "/mobile-repair-service-in-hebbagodi" },
];

const ISSUES = [
  "Display replacement",
  "Back glass swap",
  "Battery replacement",
  "Charging port repair",
  "Camera fix",
  "Speaker & mic",
  "Water damage",
  "Data recovery",
  "Chip-level work",
];

const BRANDS = [
  "Apple",
  "Samsung",
  "OnePlus",
  "Vivo",
  "Oppo",
  "Xiaomi",
  "Google Pixel",
  "Motorola",
  "Realme",
  "Nothing",
];

const ServiceShowcase = () => {
  const [showAllAreas, setShowAllAreas] = useState(false);
  const visibleAreas = showAllAreas ? AREAS : AREAS.slice(0, 18);

  return (
    <section className="service-showcase">
      <div className="showcase-left">
        <div className="eyebrow">Bengaluru Coverage</div>

        <h2>
          Doorstep pickup & delivery across{" "}
          <span className="glow-accent">45+ neighbourhoods</span>
        </h2>

        <p className="showcase-lead">
          We reach most pockets inside the ORR in 45 minutes. All visits include
          free diagnostics and sealed, tamper-proof job sheets.
        </p>

        {/* 🔥 AREAS */}
        <div className="chip-cloud">
          {visibleAreas.map((area) =>
            area.href ? (
              area.href.startsWith("http") ? (
                <a
                  key={area.label}
                  className="chip-pill chip-link"
                  href={area.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {area.label}
                </a>
              ) : (
                <Link
                  key={area.label}
                  className="chip-pill chip-link"
                  to={area.href}
                  onClick={() =>
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    })
                  }
                >
                  {area.label}
                </Link>
              )
            ) : (
              <span key={area.label} className="chip-pill disabled">
                {area.label}
              </span>
            )
          )}
        </div>

        {/* 🔥 TOGGLE BUTTON */}
        <button
          className="ghost-btn"
          onClick={() => setShowAllAreas((prev) => !prev)}
        >
          {showAllAreas
            ? "Show fewer neighbourhoods"
            : `See all ${AREAS.length} pockets`}
        </button>
      </div>

      {/* 🔥 RIGHT SIDE */}
      <div className="showcase-right">
        <div className="stack-card">
          <div className="stack-card-head">
            <p className="eyebrow">Common mobile issues we repair</p>
            <span className="pill-note">Most done same-day</span>
          </div>

          <div className="pill-grid">
            {ISSUES.map((issue) => (
              <span key={issue} className="issue-pill">
                {issue}
              </span>
            ))}
          </div>
        </div>

        <div className="stack-card">
          <div className="stack-card-head">
            <p className="eyebrow">Brands we fix</p>
            <span className="pill-note soft">OEM parts + warranty</span>
          </div>

          <div className="brand-pill-row">
            {BRANDS.map((brand) => (
              <span key={brand} className="brand-pill">
                {brand}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceShowcase;
